import { render, staticRenderFns } from "./SwitchSlider.vue?vue&type=template&id=034795a9&scoped=true&lang=pug&"
import script from "./SwitchSlider.vue?vue&type=script&lang=ts&"
export * from "./SwitchSlider.vue?vue&type=script&lang=ts&"
import style0 from "./SwitchSlider.vue?vue&type=style&index=0&id=034795a9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034795a9",
  null
  
)

export default component.exports